import React, { useContext } from 'react';

import { ActionBar, Actions, Action } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { FullScreenToggler } from '@gogame/data-grid';
import { useScreenGo } from '@gogame/screens';

import ConceptFamiliesDataTableContext from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamiliesDataTable/ConceptFamiliesDataTableContext';
import { CreateConceptFamilyForm } from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamilyForm';
import SearchField from 'scenes/Gallery/components/SearchField/SearchField';
import SwitchViewMode from 'scenes/Gallery/components/SwitchViewMode';
import {
  TAB_CONCEPT_FAMILIES,
  VIEW_MODE_TILES,
} from 'scenes/Gallery/GalleryPage/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import OrderControl from './OrderControl';

const Toolbar = ({ tabs }) => {
  const { viewMode, setViewMode } = useContext(ConceptFamiliesDataTableContext);
  const [childComponent, openChildComponent] = useChildComponent();
  const go = useScreenGo();
  const { isAllowManageConceptFamilies } = useGalleryPermissions();
  const handleAddConceptFamily = async () => {
    openChildComponent(CreateConceptFamilyForm, {
      initialValues: {},
      onSubmit: ({ id }) => {
        go(`${TAB_CONCEPT_FAMILIES}/${id}`);
      },
    });
  };

  return (
    <>
      <ActionBar
        search={<SearchField />}
        secondaryActions={
          <Actions>
            {viewMode === VIEW_MODE_TILES && (
              <Action custom={<OrderControl />} />
            )}
            <Action component={FullScreenToggler} />
          </Actions>
        }
        primaryActions={
          isAllowManageConceptFamilies ? (
            <Actions>
              <Action
                border={true}
                button={true}
                add={true}
                iconContent={true}
                tooltip={'Add Concept Family'}
                variant={'outlined'}
                onClick={handleAddConceptFamily}
              />
            </Actions>
          ) : null
        }
        modeSwitcher={
          <Actions>
            <Action
              custom={
                <SwitchViewMode viewMode={viewMode} setViewMode={setViewMode} />
              }
            />
          </Actions>
        }
      >
        {tabs}
      </ActionBar>
      {childComponent}
    </>
  );
};
export default Toolbar;
